module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery"
  }, [(_vm.galleryType === 'images' || !_vm.galleryType) ? _vm._l((_vm.images), function(image) {
    return _c('figure', {
      key: image['ID'],
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": image['sizes']['large']
      }
    }), _vm._v(" "), (image.caption) ? _c('figcaption', {
      domProps: {
        "innerHTML": _vm._s(image.caption)
      }
    }) : _vm._e()])
  }) : (_vm.galleryType === 'embed') ? [_c('div', {
    staticClass: "video-embed",
    domProps: {
      "innerHTML": _vm._s(_vm.videoEmbed)
    }
  })] : (_vm.galleryType === 'video') ? [_c('video', {
    staticClass: "video-file",
    attrs: {
      "controls": "",
      "autoplay": "",
      "playsinline": "",
      "src": _vm.videoFileUrl
    }
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6140b688!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery/GalleryFull.vue
// module id = 399
// module chunks = 2